import React, { Component } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";

class CertBlock extends Component {
    constructor() {
        super();

    }

    render() {
        return (
            <Alert style={{ width: '100%', padding: "0 1.25rem" }} variant="light">
                <div
                    style={{ display: "flex", alignItems: 'center', }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black", }}>  Сертификаты доверия</div>

                    </div>
                    <div style={{ width: "45%" }}>
                        <div style={{ padding: "0.75rem" }} className="down-block">
                            <Button
                                className="down-btn"
                                onClick={this.props.onClickGetCert}>
                                {!this.props.spinnerIsViewGetCert ? "скачать"
                                    :
                                    <Spinner
                                        style={{ width: "1rem", height: "1rem" }}
                                        animation="border"
                                        variant="light"
                                    />
                                }
                            </Button>
                        </div>
                    </div>
                </div>

            </Alert>
        );
    }
}

export default CertBlock;
